import { IState } from '../../../../../store';
import { IPhotoSchema } from '../../../../../repositories/monolith-python/entities/offer/PhotoSchema';
import { pathOr } from 'ramda';

export const photosSelector = (state: IState): IPhotoSchema[] => {
  return pathOr([], ['offerData', 'offer', 'photos'], state);
};
